import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import "./Modal.css";
import { IoIosArrowDown } from "react-icons/io";

export default function Modal({
  children,
  eventToggle,
  isOpen,
  locked = false,
  fullscreen = false
}) {
  const contentRef = useRef(null);
  const [atBottom, setAtBottom] = useState(false);

  // پیدا کردن المان اسکرول‌دار
  const getScrollContainer = () => {
    if (!contentRef.current) return null;
    return contentRef.current.querySelector(".context") || contentRef.current;
  };

  useEffect(() => {
    if (!isOpen) return;

    const scrollEl = getScrollContainer();
    if (!scrollEl) return;

    const handleScroll = () => {
      setAtBottom(
        scrollEl.scrollTop + scrollEl.clientHeight >= scrollEl.scrollHeight - 20
      );
    };

    scrollEl.addEventListener("scroll", handleScroll);
    handleScroll();

    document.body.classList.add("active-modal");

    return () => {
      scrollEl.removeEventListener("scroll", handleScroll);
      document.body.classList.remove("active-modal");
    };
  }, [isOpen]);

  const scrollToBottom = () => {
    const scrollEl = getScrollContainer();
    if (scrollEl) {
      scrollEl.scrollTo({
        top: scrollEl.scrollHeight,
        behavior: "smooth"
      });
    }
  };

  if (!isOpen) return null;

  // با پورتال، المان مستقیماً به body منتقل می‌شود و هیچ منویی نمی‌تواند روی آن بیفتد
  return ReactDOM.createPortal(
    <div className="modal">
      <div
        onClick={() => {
          !locked && eventToggle();
        }}
        className="overlay"
      ></div>

      <div
        className={`modal-content ${fullscreen ? "fullscreen" : ""}`}
        ref={contentRef}
      >
        {children}

        {!fullscreen && (
          <div
            style={{
              height: "80px",
              flexShrink: 0,
              width: "100%"
            }}
          ></div>
        )}
      </div>

      {!atBottom && (
        <button
          type="button"
          className="scroll-btn"
          onClick={scrollToBottom}
          aria-label="Scroll to bottom"
        >
          <IoIosArrowDown />
        </button>
      )}
    </div>,
    document.body
  );
}
